module.exports = __webpack_public_path__ + "src/assets/models/serological/pipette_5.fbx";